import TopicsBox from "./TopicsBox";
import { formatDate, readingTime } from "../common/format";

import {
    Link
} from "react-router-dom";

function PostTile(props) {
  return (
    <div className="post-tile">
        <Link to={props.path} className="post-tile">
            <h1 className="post-tile">{props.title}</h1>
            <h3 className="post-tile">{formatDate(props.date)} · {readingTime(props.slug)}</h3>
            <p className="post-tile">{props.preview}</p>
        </Link>
        <TopicsBox topics={props.topics} />
    </div>
  );
}

export default PostTile;
